export const whitelistUrls = [/.*westfield.*/, /.*scentregroup.*/]
